import React from 'react';
import PropTypes from 'prop-types';
import { BOX_LIMITS, BOX_PALETTE } from '@/slideshow/boxes';

/** "Add a block" for a slideshow slide: Text, Columns, Vector, Embed. */
export default function AddBoxButtons({ count = 0, onAdd, label = 'Add a block', compact = false }) {
    const full = count >= BOX_LIMITS.count;
    return (
        <div className={`flex flex-wrap items-center ${compact ? 'gap-1' : 'gap-1.5'}`} role="group" aria-label={label}>
            {!compact && <span className="mr-0.5 text-xs text-gray-500">{label}</span>}
            {BOX_PALETTE.map((entry) => (
                <button
                    key={entry.type}
                    type="button"
                    tabIndex={-1}
                    data-action-button
                    disabled={full}
                    onClick={(event) => {
                        event.stopPropagation();
                        onAdd(entry.type);
                    }}
                    title={full ? `A slide holds at most ${BOX_LIMITS.count} blocks` : `${entry.label} · ${entry.hint}`}
                    className={`rounded border border-purple-200 bg-white font-medium text-purple-700 hover:bg-purple-50 disabled:cursor-default disabled:opacity-40 ${
                        compact ? 'px-1.5 py-1 text-[11px]' : 'px-2 py-1 text-xs'
                    }`}
                >
                    {compact ? `+ ${entry.label}` : entry.label}
                </button>
            ))}
        </div>
    );
}

AddBoxButtons.propTypes = {
    /** Boxes the slide already has. */
    count: PropTypes.number,
    onAdd: PropTypes.func.isRequired,
    label: PropTypes.string,
    compact: PropTypes.bool,
};
